// /js/tiptap/ChartTemplate.js
import { Node } from '@tiptap/core'

export const ChartTemplate = Node.create({
  name: 'chart_template',
  group: 'block',

  // 🔑 THIS is where header/intro/sections belong
  //content: 'chart_header chart_intro chart_section+ chart_signature?',

  // 🔑 THIS IS THE FIX
  content: 'chart_banner? (chart_section | chart_images_section)+ chart_signature?',


  isolating: true,
  defining: true,

  /*
  addAttributes() {
    return {
      encounter_id: { default: null },
      signed: { default: false },
    }
  },
  */

  parseHTML() {
    return [{ tag: 'chart-template' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['chart-template', HTMLAttributes, 0]
  },
})
